<template>
  <div class="button-download-pdf">
    <div class="login text-center">
      <h2 class="dialogTitle">ログイン / 会員登録</h2>
      <p class="dialogSubLead">
        アカウント情報を入力してログイン・会員登録してください。
      </p>

      <div class="login_formBlock account_login">
        <p class="fieldLabel">メールアドレス</p>
        <el-input
          v-model="mailLogin.email"
          type="email"
          autocomplete
          name="mail-link-input"
          :class="'formmb'"
          placeholder="yagish@example.com"
          :disabled="loginEmailSending"
        ></el-input>
        <p class="fieldLabel">パスワード</p>
        <el-input
          v-model="mailLogin.passwd"
          type="password"
          autocomplete
          name="mail-link-input"
          :class="'formmb'"
          placeholder="パスワードを入力してください"
          :disabled="loginEmailSending"
        ></el-input>
        <p class="loginLead" v-if="emailExists !== true">
          ※初めてご利用の場合は、半角英小文字・大文字・数字を組合せて8〜20字で入力してください。記号も使用できます。
        </p>
        <template v-if="emailExists !== true">
          <p class="fieldLabel">パスワード（再入力）</p>
          <el-input
            v-model="mailLogin.passwdConfirm"
            type="password"
            autocomplete
            name="mail-link-input"
            :class="'formmb'"
            placeholder="確認のためパスワードを再入力"
            :disabled="loginEmailSending"
          ></el-input>
        </template>

        <p class="agreeLine">
          <el-checkbox v-model="isAgree">同意する</el-checkbox>
          <span class="termLead"
            >株式会社Yagishの<a href="/terms" target="_blank">利用規約</a>、<a
              href="https://www.yagish.jp/privacy_policy/"
              target="_blank"
              >プライバシーポリシー</a
            >に同意の上、ログイン（会員登録）してください。</span
          >
        </p>

        <el-button
          type="primary"
          id="account_login"
          class="account_loginbtn"
          :plain="isPlainButton"
          @click="submitIdPw"
          v-loading="loginEmailSending"
          >{{ submitButtonLabel }}</el-button
        >

        <a href="/repasswd" class="pw-change">パスワードを忘れた方はこちら</a>
        <a
          href="#"
          class="pw-change"
          v-if="$site.appFlag != 'b' && !showMailLink"
          @click.prevent="showMailLink = true"
          >メールでログインリンクを送る</a
        >
      </div>

      <div
        class="login_formBlock maillink_login"
        v-if="$site.appFlag != 'b' && showMailLink"
      >
        <p class="loginLead">
          メールに届いたリンクをクリックするだけでかんたんにログインできます。
        </p>
        <el-form
          ref="mailLoginForm"
          :model="mailLogin"
          :rules="mailLoginRules"
          @submit.native.prevent
        >
          <el-form-item :required="true" prop="email">
            <el-input
              v-model="mailLogin.email"
              type="email"
              autocomplete
              name="mail-link-input"
              :class="'formmb'"
              placeholder="yagish@example.com"
              :disabled="loginEmailSending"
            ></el-input>
          </el-form-item>
          <el-button
            type="primary"
            id="maillink_login"
            class="button-block"
            :plain="isPlainButton"
            @click="mailSubmit"
            v-loading="loginEmailSending"
            >メールでリンクを送る</el-button
          >
        </el-form>
      </div>

      <p class="orDivider"><span>またはソーシャルアカウントで</span></p>
      <div class="login_formBlock social_login">
        <div class="social_loginlist">
          <el-button
            id="google-login"
            class="social_loginitem google-login"
            @click="signInGoogle()"
            title="Googleアカウントでログイン"
          ></el-button>
          <button
            v-if="$site.appFlag != 'b'"
            id="line-login"
            class="social_loginitem line-login"
            @click="signInLine()"
            title="LINEでログイン"
          ></button>
          <button
            id="apple-login"
            class="social_loginitem apple-login"
            @click="signInApple()"
            title="appleIDでログイン"
          ></button>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.button-download-wrapper .button-download-pdf {
  background: #eef5e8;
  border-radius: 10px;
  padding: 25px;
}

.button-download-wrapper .login {
  background: #ffffff;
  border-radius: 10px;
  padding: 25px;
  max-width: 480px;
  margin: 0 auto;
}

.button-download-wrapper .el-checkbox {
  font-size: 14px;
}

.button-download-wrapper .el-checkbox__label {
  font-size: 14px;
  padding-left: 5px;
}

.button-download-wrapper .login_formBlock {
  margin-top: 20px;
  overflow: hidden;
}

.button-download-wrapper .dialogTitle {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 8px;
}

.button-download-wrapper .dialogSubLead {
  font-size: 13px;
  color: #666;
  margin-bottom: 15px;
}

.button-download-wrapper .fieldLabel {
  text-align: left;
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 6px;
}

.button-download-wrapper .agreeLine {
  display: flex;
  align-items: center;
  gap: 8px;
  text-align: left;
  margin: 10px 0 15px;
}

.button-download-wrapper .agreeLine .el-checkbox {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.button-download-wrapper .agreeLine .termLead {
  font-size: 12px;
  color: #666;
}

.button-download-wrapper .agreeLine .termLead a {
  text-decoration: underline;
}

.button-download-wrapper .pw-change {
  display: block;
  margin-top: 8px;
  color: #e3165c;
  font-size: 12px;
  text-decoration: underline;
}

.button-download-wrapper .pw-change + .pw-change {
  margin-top: 0;
}

.button-download-wrapper .orDivider {
  margin-top: 20px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  color: #999;
  font-size: 13px;
}

.button-download-wrapper .orDivider span {
  padding: 0 12px;
  white-space: nowrap;
}

.button-download-wrapper .orDivider::before,
.button-download-wrapper .orDivider::after {
  content: '';
  flex: 1;
  border-top: 1px solid #dfdfdf;
}

.button-download-wrapper .loginCategory {
  margin-bottom: 10px;
  position: relative;
  display: inline-block;
  padding: 0 30px;
}

.button-download-wrapper .loginCategory::before,
.button-download-wrapper .loginCategory::after {
  content: '';
  position: absolute;
  top: 50%;
  display: inline-block;
  width: 45px;
  height: 1px;
  background-color: #dfdfdf;
}

.button-download-wrapper .loginCategory::before {
  left: -30px;
}

.button-download-wrapper .loginCategory::after {
  right: -30px;
}

.button-download-wrapper .social_loginlist {
  display: flex;
  justify-content: center;
  gap: 15px;
}

.button-download-wrapper .social_loginitem {
  position: relative;
  background: none;
  padding: 0;
  margin: 0;
  width: 56px;
  height: 56px;
  text-align: center;
  border: 1px solid #dfdfdf;
  border-radius: 50%;
}

.button-download-wrapper .social_loginitem::before {
  position: absolute;
  content: '';
  background-image: url(/static/renew_img/icon/google.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 26px;
  height: 26px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.button-download-wrapper .line-login::before {
  background-image: url(/static/renew2_img/line_icon.jpeg);
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

.button-download-wrapper .apple-login::before {
  background-image: url(/static/renew_img/icon/appleinc.png);
  width: 22px;
  height: 26px;
}

.button-download-wrapper .account_loginbtn {
  width: 100%;
  height: 50px;
  font-weight: bold;
}

.button-download-wrapper .loginLead {
  font-size: 12px;
  margin-bottom: 10px;
  text-align: left;
}

.button-download-wrapper .el-form-item {
  margin-bottom: 0;
}

.button-download-wrapper .button-block {
  height: 50px;
  font-weight: bold;
}

@media screen and (max-width: 640px) {
  .button-download-wrapper .button-download-pdf {
    padding: 0;
    background: none;
  }

  .button-download-wrapper .login {
    padding: 0;
  }

  .button-download-wrapper .termLead {
    text-align: left;
  }

  .button-download-wrapper .dialogTitle {
    font-size: 16px;
    margin-bottom: 4px;
  }

  .button-download-wrapper .dialogSubLead {
    font-size: 11px;
    margin-bottom: 8px;
  }

  .button-download-wrapper .login_formBlock {
    margin-top: 8px;
  }

  .button-download-wrapper .fieldLabel {
    font-size: 12px;
    margin-bottom: 3px;
  }

  .button-download-wrapper .formmb ::v-deep .el-input__inner {
    height: 40px;
    margin-bottom: 6px;
  }

  .button-download-wrapper .loginLead {
    font-size: 10px;
    margin-bottom: 6px;
  }

  .button-download-wrapper .agreeLine {
    margin: 6px 0 8px;
  }

  .button-download-wrapper .agreeLine .termLead {
    font-size: 11px;
  }

  .button-download-wrapper .account_loginbtn,
  .button-download-wrapper .button-block {
    height: 40px;
  }

  .button-download-wrapper .pw-change {
    margin-top: 4px;
  }

  .button-download-wrapper .orDivider {
    margin-top: 8px;
    margin-bottom: 8px;
  }

  .button-download-wrapper .social_loginlist {
    gap: 10px;
  }

  .button-download-wrapper .social_loginitem {
    width: 40px;
    height: 40px;
  }
}
</style>
<style lang="scss" scoped>
.button-download-wrapper {
  .formmb {
    ::v-deep .el-input__inner {
      height: 50px;
      margin-bottom: 10px;
    }
  }
}
</style>
<script>
import { emitter } from '@/plugins/emitter'
import _ from '@/assets/lib/my-lodash'
export default {
  props: {
    isPlainButton: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loginEmailSending: false,
      isAgree: true,
      showMailLink: false,
      emailExists: null,
      mailLogin: {
        email: '',
        passwd: '',
        passwdConfirm: ''
      },
      mailLoginRules: {
        email: [
          {
            required: true,
            message: 'メールアドレスをいれてね',
            trigger: 'blur'
          },
          {
            required: true,
            type: 'email',
            message: 'メールアドレスをいれてね',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    },
    // メールアドレスの登録有無が判明するまでは、どちらの操作になるか確定しないため両方を示す。
    // 判明後は実際に起きる操作だけを出して「ログインしたつもりが会員登録された」という誤解を防ぐ。
    // なお emailExists は表示上のヒントに過ぎない。実際にログインか登録かを決めるのは
    // submitIdPw のログイン試行なので、この値が外れても操作が失敗することはない。
    submitButtonLabel: function () {
      if (this.emailExists === true) {
        return 'ログインする'
      }
      if (this.emailExists === false) {
        return '会員登録する'
      }
      return 'ログイン・会員登録する'
    }
  },
  watch: {
    'mailLogin.email': function (email) {
      this.emailExists = null
      if (this.isInValidEmail(email)) {
        return
      }
      this.checkEmailExistsDebounced(email)
    }
  },
  methods: {
    checkEmailExistsDebounced: _.debounce(function (email) {
      this.$firebase.checkEmailExists(email).then((exists) => {
        if (this.mailLogin.email === email) {
          this.emailExists = exists
        }
      })
    }, 400),
    applyBasicDataEmail: function (basicData) {
      if (basicData && basicData.email && !this.mailLogin.email) {
        this.mailLogin.email = basicData.email
      }
    },
    isInValidEmail: function (mailStr) {
      const reg =
        /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/
      return !reg.test(mailStr)
    },
    isValidPassword: function (password) {
      if (password.length < 8 || password.length > 20) {
        return false
      }
      const hasLowerCase = /[a-z]/.test(password)
      const hasUpperCase = /[A-Z]/.test(password)
      const hasNumber = /\d/.test(password)
      return hasLowerCase && hasUpperCase && hasNumber
    },
    submitIdPw: async function () {
      if (!this.isAgree) {
        this.$message({
          message: '利用規約と個人情報の扱いに同意してください。',
          type: 'error'
        })
        return
      }
      if (this.isInValidEmail(this.mailLogin.email)) {
        this.$message({
          message: 'メールアドレスを正しく入力してください',
          type: 'error'
        })
        return
      }
      if (!this.mailLogin.passwd) {
        this.$message({
          message: 'パスワードを入力してください',
          type: 'error'
        })
        return
      }
      this.loginEmailSending = true
      try {
        // 登録済みかどうかの判定は checkEmailExists ではなく実際のログイン試行に任せる。
        // fetchSignInMethodsForEmail は Firebase の Email enumeration protection が有効だと
        // 常に空配列を返すため、emailExists === false を「未登録」と断定できない。
        //
        // 注意: protection が有効化されると既存ユーザーも emailExists === false になるため、
        // ボタンは「会員登録する」と表示されたままログインが成功する（表示と実際の操作がずれる）。
        // 空配列が「未登録」なのか「protection で伏せられた」のかはクライアントから区別できないので、
        // 表示のずれは避けられない。ずれても入れるほうが、ログイン不能になるより望ましいと判断して
        // この経路を採っている。
        const signInResult = await this.$firebase.signInEmailPasswd(
          this.mailLogin.email,
          this.mailLogin.passwd,
          { signupFallback: true }
        )
        // true ならログイン成功、false なら利用停止などで登録に回しても無意味な失敗
        // （signInEmailPasswd 側がメッセージを出している）。どちらもここで終わり。
        if (signInResult !== 'retry-as-signup') {
          return
        }

        // 登録済みだと判明しているアドレスでログインできなかった場合は、パスワード違いとして
        // 案内して終わる。ここで登録に回すと、画面に出ていない「確認用パスワード」の
        // 不一致エラーが出てしまう（emailExists === true のときは再入力欄が非表示のため）。
        // Email enumeration protection が有効だと emailExists は true にならないので、
        // その場合はこの分岐を通らず下の登録経路で email-already-in-use として拾われる。
        if (this.emailExists === true) {
          this.$message({
            message:
              'ログインに失敗しました。メールアドレスまたはパスワードが違います',
            type: 'error'
          })
          return
        }
        // ログインできず、未登録の可能性があるので新規登録として扱う。
        // 確認用パスワードの一致と形式チェックはここまで遅らせている。ログイン試行より前に
        // 弾くと、isValidPassword の条件（8〜20字・英小文字大文字数字の混在）を満たさない
        // パスワードで登録済みの既存ユーザーがログイン不能になる（Firebase 側の最低要件は6文字）。
        if (this.mailLogin.passwd !== this.mailLogin.passwdConfirm) {
          this.$message({
            message: 'パスワードと確認用パスワードが一致していません。',
            type: 'error'
          })
          return
        }
        if (!this.isValidPassword(this.mailLogin.passwd)) {
          this.$message({
            message:
              'パスワードを正しい形式で入力してください。※半角英小文字・大文字・数字を組合せて8〜20字で入力してください。記号も使用できます。',
            type: 'error'
          })
          return
        }
        await this.$firebase.signOnEmailPasswd(
          this.mailLogin.email,
          this.mailLogin.passwd,
          { signInAlreadyTried: true }
        )
      } catch (error) {
        console.error(error)
        this.$message({
          message: 'エラーが発生しました。もう一度お試しください。',
          type: 'error'
        })
      } finally {
        this.loginEmailSending = false
      }
    },
    signInGoogle: function () {
      if (!this.isAgree) {
        this.$message({
          message: '利用規約と個人情報の扱いに同意してください。',
          type: 'error'
        })
        return
      }
      this.$firebase.signInGoogle()
    },
    signInLine: function () {
      if (!this.isAgree) {
        this.$message({
          message: '利用規約と個人情報の扱いに同意してください。',
          type: 'error'
        })
        return
      }
      this.$firebase.signInLine()
    },
    signInApple: function () {
      if (!this.isAgree) {
        this.$message({
          message: '利用規約と個人情報の扱いに同意してください。',
          type: 'error'
        })
        return
      }
      this.$firebase.signInApple()
    },
    resetloginEmail: function () {
      this.mailLogin.email = ''
      this.loginEmailSending = false
      this.$refs.mailLoginForm.resetFields()
    },
    mailSubmit: function () {
      if (!this.isAgree) {
        this.$message({
          message: '利用規約と個人情報の扱いに同意してください。',
          type: 'error'
        })
        return
      }
      const app = this
      this.$refs.mailLoginForm.validate(async (valid) => {
        if (!valid) {
          return
        }
        app.$firebase.signInEmail(app.mailLogin.email)
        app.loginEmailSending = true
      })
    }
  },
  mounted: function () {
    this.$eventHub.$on('sing-in-mail-send', this.resetloginEmail)
    this.$eventHub.$on('sing-in-mail-failed', this.resetloginEmail)
    emitter.on('basic-data-changed', this.applyBasicDataEmail)
    this.$getItem('basicData', (err, data) => {
      if (!err) {
        this.applyBasicDataEmail(data)
      }
    })
  },
  destroyed: function () {
    this.$eventHub.$off('sing-in-mail-send', this.resetloginEmail)
    this.$eventHub.$off('sing-in-mail-failed', this.resetloginEmail)
    emitter.off('basic-data-changed', this.applyBasicDataEmail)
  }
}
</script>
